import { useMemo } from 'react';

import styles from './styles.module.css';
import {
  createSummaryLeftColumns,
  createSummaryRightColumns,
  createSummaryLeftRows,
  createSummaryRightRows,
  createTemperaturesColumns,
  createTemperaturesRows
} from './utils';
import parentStyles from '../../styles.module.css';
import { StatusIndicatorWithStyles } from '../ControlTab/utils';
import Card from '@/components/Card';
import DataTable from '@/components/DataTable';
import EmptyState from '@/components/EmptyState';
import GridContainer from '@/components/GridContainer';
import {
  getGeneratorSummaryPath,
  getGeneratorTemperaturesPath
} from '@/solaris-lens-common-lib/src/utils/turbinesPaths';

const summaryLeftColumns = createSummaryLeftColumns(StatusIndicatorWithStyles);
const summaryRightColumns = createSummaryRightColumns();

export default function GeneratorTab({ turbineData }: { turbineData: any }) {
  const initialSummaryData = useMemo(() => {
    if (turbineData) {
      return getGeneratorSummaryPath(turbineData) || {};
    }
    return {};
  }, [turbineData]);

  const initialTemperatureData = useMemo(() => {
    if (turbineData) {
      return getGeneratorTemperaturesPath(turbineData) || [];
    }
    return [];
  }, [turbineData]);

  const summaryLeftRows = useMemo(
    () => createSummaryLeftRows(initialSummaryData),
    [initialSummaryData]
  );

  const summaryRightRows = useMemo(
    () => createSummaryRightRows(initialSummaryData),
    [initialSummaryData]
  );

  const temperaturesColumns = createTemperaturesColumns();
  const temperaturesRows = useMemo(
    () => createTemperaturesRows(initialTemperatureData),
    [initialTemperatureData]
  );

  const hasData =
    summaryLeftRows.length > 0 ||
    summaryRightRows.length > 0 ||
    temperaturesRows.length > 0;

  if (!hasData) {
    return (
      <EmptyState
        title="No data available"
        subtitle="No data available for this tab."
      />
    );
  }

  return (
    <GridContainer
      gap="30px"
      className={parentStyles.gridContainerLeft}
      align="none"
    >
      <Card title="Summary">
        <GridContainer columns={2} gap="30px" independentHeight>
          {summaryLeftRows.length > 0 && (
            <DataTable
              rows={summaryLeftRows}
              columns={summaryLeftColumns}
              type="detail"
              getRowId={row => row.key}
              noLeftMargin={true}
              alignTextLeft={true}
              className={styles.controlTable}
            />
          )}
          {summaryRightRows.length > 0 && (
            <DataTable
              rows={summaryRightRows}
              columns={summaryRightColumns}
              type="detail"
              getRowId={row => row.key}
              noLeftMargin={true}
              alignTextLeft={true}
              className={styles.controlTable}
            />
          )}
        </GridContainer>
      </Card>
      {temperaturesRows.length > 0 && (
        <Card title="Temperatures">
          <DataTable
            rows={temperaturesRows}
            columns={temperaturesColumns}
            type="detail"
            getRowId={row => row.key}
            noLeftMargin={true}
            alignTextLeft={true}
            className={styles.controlTable}
          />
        </Card>
      )}
    </GridContainer>
  );
}
